var React = require('react');

function ShapesCircleInline (props) {
    return React.createElement("svg",props,React.createElement("rect",{"x":"1.08025","y":"0.719101","width":"360","height":"360","rx":"180","stroke":"#FF00FF"}));
}

ShapesCircleInline.defaultProps = {"viewBox":"0 0 362 362","fill":"none"};

module.exports = ShapesCircleInline;

ShapesCircleInline.default = ShapesCircleInline;
